/**
 * @returns {import("~/config/useGetRichtTextValues").RichTextValuesLocales}
 */
export const fseRichtTextValues = {
  'de-DE': {
    contactEmail: 'karriere@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/job-suche',
    disclaimerUrl: '/datenschutz',
  },
  'en-US': {
    contactEmail: 'careers@fresenius.com',
    homeUrl: '/en-US/',
    jobSearchUrl: '/en-US/job-search',
    disclaimerUrl: '/en-US/data-protection',
  },
  'es-ES': {
    contactEmail: 'karriere@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/buscar-empleo',
    disclaimerUrl: '/privacy-policy',
  },
};
